import React from 'react';
import H from '../../typography/H';
import Eyebrow from '../../typography/Eyebrow';
const eyebrowStyles = {
    lineHeight: 1
};
const EyebrowHeading = ({ heading, eyebrow, centered = false, styles }) => (React.createElement("header", { style: styles },
    React.createElement(Eyebrow, { centered: centered, type: "bold", styles: eyebrowStyles }, eyebrow),
    React.createElement(H, { role: "h4", centered: centered }, heading)));
export default EyebrowHeading;
//# sourceMappingURL=index.js.map